import { HStack } from '@chakra-ui/react';
import { IconButton } from 'Atoms';
import { Typography } from 'Tokens';
import { HelpIcon, WarningIcon } from 'Tokens/Icons/Status';

export const MaintenanceBanner = ({
  setMaintenanceModalOpen,
}: {
  setMaintenanceModalOpen: () => void;
}) => {
  return (
    <HStack
      backgroundColor="bg.decor.08"
      padding="10px 40px"
      justifyContent="center"
      position="relative"
    >
      <WarningIcon color="text.onAccent" />
      <Typography variant="bodyStrong" color="text.onAccent">
        System update in progress: You may encounter temporary issues. This should only take a few
        minutes. Thank you for your patience!
      </Typography>
      <IconButton
        aria-label={'more-info-maintenance'}
        position="absolute"
        top="50%"
        right="16px"
        transform="translateY(-50%)"
        variant="ghost"
        onClick={setMaintenanceModalOpen}
        icon={<HelpIcon color="text.onAccent" />}
        size="xs"
      />
    </HStack>
  );
};
